type Props = (route?: string, navigate?: boolean, organization?: string | null) => any

declare module 'vue' {
   interface ComponentCustomProperties {
      $dashboardNavigation: Props
   }
}

export default defineNuxtPlugin(async (nuxtApp) => {
   const localePath = useLocalePath()
   const organizationId = useOrganizationId()

   return {
      provide: {
         dashboardNavigation: (route: string, navigate?: boolean, organization?: string | null) => {
            const org = organization || organizationId.value
            const [path, queryString] = route.split('?')
            const localizedPath = localePath(`/dashboard/${org}/${path}`)
            const fullPath = queryString ? `${localizedPath}?${queryString}` : localizedPath
            if (navigate) {
               return navigateTo(fullPath)
            } else {
               return fullPath
            }
         },
      },
   }
})
